import { ComponentType } from 'react';
import { EnumBehaviorKey } from 'src/types/Behaviors';
import { AppRoute } from 'src/types/Route';

export function defineRoute<C extends ComponentType<any>>(route: AppRoute<C>) {
  return route;
}

/** 是否显示route */
export function showRoute(route: AppRoute, behaviorKeys: EnumBehaviorKey[]) {
  if (!route.behaviors) {
    return true;
  }
  if (!behaviorKeys.length) {
    return false;
  }
  return route.behaviors.some(behavior => behaviorKeys.includes(behavior));
}
